import request from "../utils/request";

export async function getDistributorList(payload) {
  return request.get("Supplier/Distributors", {
    params: {
      distributorId: payload.distributor ? payload.distributor.id : null,
      supplierId: payload.supplier ? payload.supplier.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      email: payload.distributorEmail ? payload.distributorEmail.id : null,
      phoneNumber: payload.distributorPhoneNumber ? payload.distributorPhoneNumber.name : null,
      ownerName: payload.distributorOwner ? payload.distributorOwner.name : null,
      bankName: payload.distributorBank ? payload.distributorBank.name : null,
      bankAccount: payload.distributorBankAccount ? payload.distributorBankAccount.name : null,
      address: payload.distributorAddress ? payload.distributorAddress.name : null
    }
  });
}
export async function createNewDistributor(newDistributor) {
  return request.post("Supplier/CreateDistributor", newDistributor);
}
export async function updateDistributor(distributor) {
  return request.post("Supplier/UpdateDistributor", distributor);
}
export async function deleteDistributor(id) {
  return request.delete('Supplier/DeleteDistributor?id=' + id);
}
export async function getDistributorNameList() {
  return request.get("Supplier/NameList");
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
